import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Portfolio card with an internal image slider.
// Add more images to `images` array and the slider arrows appear automatically.
export default function PortfolioCard({ item, index }) {
  const [i, setI] = useState(0);
  const total = item.images.length;
  const multi = total > 1;

  const prev = () => setI((n) => (n - 1 + total) % total);
  const next = () => setI((n) => (n + 1) % total);

  return (
    <div data-testid={`portfolio-item-${index}`}>
      <div className="group relative overflow-hidden rounded-3xl bg-surface shadow-soft">
        <div className="relative h-72 w-full overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.img
              key={i}
              src={item.images[i]}
              alt={`${item.label.join(" ")} — ${item.client}`}
              initial={{ opacity: 0, scale: 1.03 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
              className="absolute inset-0 h-full w-full object-cover"
            />
          </AnimatePresence>
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-navy/40 to-transparent" />

          {/* Client badge */}
          <div className="absolute bottom-4 left-1/2 z-10 -translate-x-1/2">
            <span className="inline-block whitespace-nowrap rounded-md bg-navy px-4 py-1.5 text-sm font-semibold text-white shadow-lift">
              {item.client}
            </span>
          </div>

          {/* Slider controls */}
          {multi && (
            <>
              <button
                onClick={prev}
                aria-label="Gambar sebelumnya"
                data-testid={`portfolio-prev-${index}`}
                className="absolute left-3 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-white/85 text-navy backdrop-blur transition-transform duration-300 hover:scale-110 active:scale-95"
              >
                <ChevronLeft className="h-5 w-5" />
              </button>
              <button
                onClick={next}
                aria-label="Gambar berikutnya"
                data-testid={`portfolio-next-${index}`}
                className="absolute right-3 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-white/85 text-navy backdrop-blur transition-transform duration-300 hover:scale-110 active:scale-95"
              >
                <ChevronRight className="h-5 w-5" />
              </button>

              {/* dots */}
              <div className="absolute bottom-14 left-1/2 z-10 flex -translate-x-1/2 gap-1.5">
                {item.images.map((_, d) => (
                  <span
                    key={d}
                    className={`h-1.5 rounded-full transition-all duration-300 ${d === i ? "w-5 bg-white" : "w-1.5 bg-white/50"}`}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Label below */}
      <div className="mt-5 text-center">
        <h3 className="text-xl font-bold leading-tight tracking-tight text-navy">
          {item.label.map((line, li) => (
            <span key={li} className="block">{line}</span>
          ))}
        </h3>
      </div>
    </div>
  );
}
